import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	ai_answer_component_ai_answer_open_chat: {
		id: 'search_ai.ai_answer_open_chat',
		defaultMessage: 'Open chat',
		description: 'Label text for the ai answer open chat button',
	},
	ai_answer_component_ai_answer_ask_more_chat: {
		id: 'search_ai.ai_answer_ask_more_chat',
		defaultMessage: 'Ask more in Chat',
		description: 'Label text for the ai answer ask more in chat text input',
	},
	ai_answer_component_ai_answer_ask_more_chat_submit: {
		id: 'search_ai.ai_answer_ask_more_chat_submit',
		defaultMessage: 'Submit',
		description: 'Label text for the ai answer ask more in chat text input submit button',
	},
});
